// src/services/api/manufacturing.ts
import { apiClient, ApiResponse, PaginatedResponse } from './index';

export interface ManufacturingLog {
  id: number;
  menu_item: {
    id: number;
    name: string;
    category: string[];  // Массив названий категорий
  };
  quantity_added: number;
  timestamp: string;
  created_by: string;
  comment: string;
}

export interface ManufacturingStats {
  period: string;
  date_from: string;
  date_to: string;
  total_stats: {
    total_quantity: number;
    total_records: number;
  };
  daily_stats: Array<{
    day: string;
    total_quantity: number;
    records_count: number;
  }>;
  top_items: Array<{
    menu_item__id: number;
    menu_item__name: string;
    total_quantity: number;
    records_count: number;
  }>;
}

export interface StockStatus {
  menu_item: {
    id: number;
    name: string;
    current_stock: number;
    total_manufactured: number;
    cart_reserved_quantity: number;
    pending_quantity: number;
    confirmed_quantity: number;
    preparing_quantity: number;
    delivering_quantity: number;
    completed_quantity: number;
    abandoned_quantity: number;
    stock_available: number;
    is_available_for_order: boolean;
  };
  recent_manufacturing: ManufacturingLog[];
}

export const manufacturingApi = {
  // Получить список логов производства
  getLogs: (params?: {
    page?: number;
    limit?: number;
    menu_item?: number;
    menu_item__category?: number;
    date_from?: string;
    date_to?: string;
    search?: string;
    ordering?: string;
  }) =>
    apiClient.get<ApiResponse<PaginatedResponse<ManufacturingLog>>>('/api/admin/manufacturing/logs/', {
      params
    }),

  // Создать запись о производстве (created_by заполняется автоматически на бэкенде)
  createLog: (data: {
    menu_item: number;
    quantity_added: number;
    comment?: string;
  }) =>
    apiClient.post<ApiResponse<ManufacturingLog>>('/api/admin/manufacturing/logs/create/', data),

  // Массовое создание записей
  bulkCreateLogs: (items: Array<{
    menu_item: number;
    quantity_added: number;
    comment?: string;
  }>) =>
    apiClient.post<ApiResponse<{
      success_count: number;
      error_count: number;
      created: any[];
      errors: any[];
    }>>('/api/admin/manufacturing/logs/bulk-create/', { items }),

  // Получить конкретную запись
  getLog: (logId: number) =>
    apiClient.get<ApiResponse<ManufacturingLog>>(`/api/admin/manufacturing/logs/${logId}/`),

  // Удалить запись
  deleteLog: (logId: number) =>
    apiClient.delete<ApiResponse<{ message: string }>>(`/api/admin/manufacturing/logs/${logId}/`),

  // Получить статистику производства
  getStats: (params?: {
    days?: number;  // По умолчанию 7
  }) =>
    apiClient.get<ApiResponse<ManufacturingStats>>('/api/admin/manufacturing/stats/', {
      params
    }),

  // Получить детальный статус запасов блюда
  getStockStatus: (menuItemId: number) =>
    apiClient.get<ApiResponse<StockStatus>>(`/api/admin/manufacturing/stock-status/${menuItemId}/`),
};